import { Component, OnInit, Input  } from '@angular/core';

@Component({
  selector: 'app-star-rating',
  templateUrl: './star-rating.component.html',
  styleUrl: './star-rating.component.scss'
})
export class StarRatingComponent {
  @Input() rating:any;
  constructor() { }
  ngOnInit() { }
}
